export enum ClientConstantType {
  default = 'default',
  paepae = 'paepae',
  wastemanagement = 'wastemanagement',
  waikatotainui = 'waikatotainui',
  patuharakeke = 'patuharakeke',
  waitaha = 'waitaha',
  ngatiawataikapiti = 'ngatiawataikapiti',
  kapiti = 'kapiti',
  tahaaroa = 'tahaaroa',
  tapuika = 'tapuika',
  maahanga = 'maahanga',
  ngatihauiti = 'ngatihauiti',
  ngawairikingatiapa = 'ngawairikingatiapa',
  ngatikuri = 'ngatikuri',
  ranana = 'ranana',
  ngatimanuhiri = 'ngatimanuhiri',
  ngatiira = 'ngatiira',
  hurakiatrust = 'hurakiatrust',
  tearataki = 'tearataki',
  teuriohau = 'teuriohau',
  raukawa = 'raukawa',
}
